// extracted by mini-css-extract-plugin
export default {"modal":"UserSurvey_modal__pMTVA"};